<template>
  <div class="common-table__row attachment-item"
       :class="{'attachment-item_expanded' : attachment.expanded}">
    <div class="attachment-item__content" :class="{'attachment-item__content_expanded' : attachment.expanded}">
      <div class="common-table__cell attachment-item__name ">
        <base-material-design-icon
          v-if="attachment.type === 'file'"
          class="icon icon__file"
          icon="plus"/>
        <base-material-design-icon
          v-else
          class="icon icon__link"
          icon="insertLink"/>

        <template v-if="isPublishTab">
          <div class="publish-grid">
            <span class="attachment-item__link-wrap"
                  :class="{'attachment-item__link-wrap_expanded': attachment.expanded}">
                  {{ attachment.image_name }}
            </span>
            <base-material-design-icon icon="copy"
            v-tooltip.top-start="{content: 'Copy', ...tooltipOptions}"
            @click="copyToClipboard(attachment.image_name)"
            class="publish-icon" />
            <span class="attachment-item__link-wrap"
                  :class="{'attachment-item__link-wrap_expanded': attachment.expanded}">
                  {{ attachment.image_name_alt }}
            </span>
            <base-material-design-icon icon="copy"
            v-tooltip.top-start="{content: 'Copy', ...tooltipOptions}"
            @click="copyToClipboard(attachment.image_name_alt)"
            class="publish-icon" />
            <span class="attachment-item__link-wrap"
                  ref="link"
                  :class="{'attachment-item__link-wrap_expanded': attachment.expanded}">
              <a class="attachment-item__link"
                :title="attachment.name"
                :href="attachment.link"
                target="_blank"
                >{{ attachment.link }}</a>
            </span>
            <base-material-design-icon icon="copy"
            v-tooltip.top-start="{content: 'Copy', ...tooltipOptions}"
            @click="copyToClipboard(attachment.link)"
            class="publish-icon" />
          </div>
        </template>
        <template v-else>
          <span class="attachment-item__link-wrap"
                ref="link"
                :class="{'attachment-item__link-wrap_expanded': attachment.expanded}">
            <a class="attachment-item__link"
              :title="attachment.name"
              :href="attachment.link"
              target="_blank"
              :download="attachment.name"
              v-if="attachment.type === 'file'">{{ attachment.description || attachment.label }}</a>
            <a class="attachment-item__link"
              :title="attachment.name"
              :href="attachment.link"
              target="_blank"
              v-else>{{ attachment.description || attachment.link }}</a>
          </span>
        </template>
      </div>
<!--      <div v-if="attachment.expanded" class="common-table__cell attachment-item__description"-->
<!--           :class="{'attachment-item__description_expanded': attachment.expanded}" ref="description">-->
<!--        {{attachment.description}}-->
<!--      </div>-->
    </div>
    <div v-if="!removeIds.includes(attachment.id)" class="common-table__cell attachment-item__cross-wrapper">
      <title-dropdown-menu class="attachment-item__menu"
                           :options="dropdownOptions"
                           @menuItem="onItemClick" />
      <span class="attachment-item__expand-button"
            :class="{'attachment-item__expand-button_expanded': attachment.expanded,
            'attachment-item__expand-button_hidden': !isNeedCollapse}"
            @click.stop="toggleExpandState()"></span>
    </div>
    <base-horizontal-loader v-else
            class="attachment-item__remove-loader" />
  </div>
</template>

<script>
import _ from 'lodash'
import ToasterService from '@/services/toasterService'
import TitleDropdownMenu from './TitleDropdownMenu'
const DROPDOWN_OPTIONS = [
  {
    label: 'Edit',
    id: 'edit'
  },
  {
    label: 'Delete',
    id: 'delete'
  }
]
/**
 * List item component for {@link ./Attachments}
 */
export default {
  name: 'AttachmentItem',
  props: [ 'attachment', 'removeIds', 'isPublishTab' ],
  components: {
    TitleDropdownMenu
  },
  mounted () {
    this.recalculateCollapsed()
  },
  data () {
    return {
      isNeedCollapse: true,
      dropdownOptions: _.cloneDeep(DROPDOWN_OPTIONS),
      tooltipOptions: {
        delay: { show: 100, hide: 100 },
        classes: 'rfx-tooltip-arrow'
      }
    }
  },
  watch: {
    attachment: {
      handler () {
        this.recalculateCollapsed()
      },
      deep: true
    }
  },
  methods: {
    copyToClipboard (text) {
      this.$copyText(text)
        .then(
          e => {
            ToasterService.showToast(ToasterService.INFO_TYPE, 'Copied to clipboard')
          }
        )
    },
    onItemClick (item) {
      switch (item) {
        case 'delete':
          this.$emit('remove')
          break
        case 'edit':
          this.$emit('update', this.attachment)
          break
      }
    },
    recalculateCollapsed () {
      const linkElement = this.$refs.link
      const linkOuterWidth = linkElement.clientWidth
      const linkInnerWidth = linkElement.scrollWidth
      const isCurrentExpanded = !!this.$el.querySelector('.attachment-item__content_expanded')
      // if (!this.attachment.description && !this.attachment.description.length && linkInnerWidth <= linkOuterWidth && !isCurrentExpanded) {
      if (linkInnerWidth <= linkOuterWidth && !isCurrentExpanded) {
        this.isNeedCollapse = false
      } else {
        if (isCurrentExpanded && !this.attachment.expanded && !this.attachment.prevExpanded) {
          this.attachment.expanded = isCurrentExpanded
        }
        this.isNeedCollapse = true
      }
    },
    toggleExpandState () {
      if (!this.isNeedCollapse) {
        return
      }
      this.attachment.prevExpanded = this.attachment.expanded
      this.attachment.expanded = !this.attachment.expanded
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../../assets/variables';

  .attachment-item {
    height: 45px;
    border-bottom: 1px solid #f5f5f5;

    &__action {
      &:hover {
        color: #284aff;
      }
    }

    &__menu {
      margin-top: 20px;
      margin-left: -20px;

      &::v-deep .title-dropdown-menu__icon {
        background-color: #011627;

        &:before {
          background-color: #011627;
          top: -6px;
        }
        &:after {
          background-color: #011627;
          top: 6px;
        }
      }

      &::v-deep .title-dropdown-menu__item-icon {
        font-size: 22px;
      }
    }

    &__content {
      flex: 0 0 90%;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      &_expanded {
        overflow: visible;
      }
    }

    &__cross {
      cursor: pointer;
      font-size: 25px;
      position: absolute;
      right: 12px;
      top: 17px;
      color: $rfx-light-red;

      &:hover {
        color: $rfx-red;
      }
    }

    &__remove-loader {
      margin-top: -7px;
      transform: scale(.4) translateX(-100px);
    }

    &__edit {
      cursor: pointer;
      font-size: 25px;
      position: absolute;
      right: 42px;
      top: 17px;
    }

    &__save {
      cursor: pointer;
      font-size: 30px;
      position: absolute;
      right: 70px;
      top: 15px;
    }

    &__undo {
      cursor: pointer;
      font-size: 30px;
      position: absolute;
      right: 42px;
      transform: rotate(45deg);
      top: 15px;
    }

    &__cross-wrapper {
      position: relative;
      border-bottom: none;
      padding: 0;
      margin-top: -8px;
    }

    &__link {
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }

      &-wrap {
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 0 0 95%;
        display: block;
        white-space: nowrap;

        &_expanded {
          white-space: initial;
          word-break: break-all;
        }
      }

      &_input {
        border: none;
        outline: none;
        width: 100%;
        font-size: 13px;
        padding: 0;

        &:hover {
          text-decoration: none;
        }
      }
    }

    &__input {
      &_err {
        &::placeholder {
          color: $rfx-light-red;
        }
      }
    }

    &__name {
      display: flex;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-bottom: none;
      padding-bottom: 6px;
      padding-top: 12px;
      font-size: 14px;
      line-height: 20px;
    }

    &_expanded {
      height: auto;
    }

    &__description {
      width: 105%;
      padding-top: 6px;
      padding-bottom: 12px;
      margin-left: 37px;
      overflow: hidden;
      text-overflow: ellipsis;
      border-bottom: none;
      white-space: nowrap;
      font-size: 14px;
      line-height: 20px;
      color: $rfx-medium-march;
      box-sizing: border-box;

      &_expanded {
        max-height: none;
        white-space: normal;
        word-break: break-word;
      }

      &_input {
        border: none;
        border-bottom: 1px solid #f5f5f5;
        outline: none;
      }
    }

    &__expand-button {
      cursor: pointer;
      position: absolute;
      top: 26px;
      right: 29px;
      width: 7px;
      height: 7px;
      border-left: 2px solid $rfx-dark-march;
      border-bottom: 2px solid $rfx-dark-march;
      transform: translate(5px, -2px) rotate(-45deg);

      &_expanded {
        transform: translate(5px, 2px) rotate(135deg);
      }

      &_hidden {
        display: none;
      }
    }

    &:last-child {
      border-radius: 0 0 4px 4px;
    }
  }

  .icon {
    display: inline-block !important;
    color: $rfx-blue;

    &__link {
      margin-top: 2px;
      margin-right: 27px;
      font-size: 17px;
      margin-bottom: auto;
      width: 0;
    }

    &__file {
      margin-right: 17px;
      margin-top: -7px;
    }

    &_clickable {
      cursor: pointer;
    }
  }

  .publish-grid {
			display: grid;
			grid-template-columns: 2fr 1fr 2fr 1fr 4fr 1fr;
      width: 100%;
  }

  .publish-icon {
    margin-left: 10px;
    margin-bottom: -5px;
    // height: 120px;
  }

</style>
